import { useState, useEffect } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useRentals = () => {
  const [rentalData, setRentalData] = useState([]);
  const [purposes, setPurposes] = useState([]);

  const getEventPurposes = async () => {
    try {
      const response = await getApi(apiEndPoints.getRentalPurpose);
      setPurposes(response.data.data);
    } catch (error) {
      console.error("Error fetching rental purposes:", error);
    }
  };

  const getRentalsData = async () => {
    try {
      const response = await getApi(apiEndPoints.getRental);
      setRentalData(response.data.data);
    } catch (error) {
      console.error("Error fetching rentals:", error);
    }
  };

  useEffect(() => {
    getRentalsData();
    getEventPurposes();
  }, []);

  return { rentalData, purposes };
};

export default useRentals;